import React from 'react';
import { Page } from './Page';
export function FoodPhoto({
  src,
  alt,
  caption,
  pageNumber
}: {
  src: string;
  alt: string;
  caption?: string;
  pageNumber?: number;
}) {
  return <Page hideFooter variant="light" data-id="element-76">
      <div className="flex flex-col h-full -mx-4 -mt-2" data-id="element-77">
        <div className="flex-1 overflow-hidden min-h-0" data-id="element-78">
          <img src={src} alt={alt} className="w-full h-full object-cover" data-id="element-79" />
        </div>
        <div className="flex items-start justify-between pt-4 px-1" data-id="element-80">
          <p className="text-[11px] text-[#7A7A70] tracking-wide" data-id="element-81">
            {caption || 'Structured Nutrition | The GLP-1 Nutrition Guide'}
          </p>
          <div className="flex flex-col items-center gap-1 shrink-0 ml-4" data-id="element-82">
            <div className="w-12 h-12 border border-[#D8D8D0] bg-[#EAEAE4] flex items-center justify-center" data-id="element-83">
              <span className="text-[8px] font-bold text-[#7A7A70]" data-id="element-84">QR</span>
            </div>
            <p className="text-[8px] text-[#7A7A70]" data-id="element-85">Scan to get the recipe</p>
          </div>
        </div>
      </div>
    </Page>;
}